import { platform, PlatformType } from "~ui-lib";

import { loadJS } from "./loadJS";

const _magnetoScriptUrls: Record<PlatformType, Record<"prod" | "pre", string>> = {
  "Smart TV (Generic)": {
    prod: "https://static.francetv.fr/magnetoscope-webos/main.magnetoscope.js",
    pre: "https://static.ftv-preprod.fr/magnetoscope-webos/main.magnetoscope.js",
  },
  "Hisense TV": {
    prod: "https://static.francetv.fr/magnetoscope-vidaa/main.magnetoscope.js",
    pre: "https://static.ftv-preprod.fr/magnetoscope-vidaa/main.magnetoscope.js",
  },
  "LG TV": {
    prod: "https://static.francetv.fr/magnetoscope-webos/main.magnetoscope.js",
    pre: "https://static.ftv-preprod.fr/magnetoscope-webos/main.magnetoscope.js",
  },
  "Samsung TV": {
    prod: "https://static.francetv.fr/magnetoscope-tizen/main.magnetoscope.js",
    pre: "https://static.ftv-preprod.fr/magnetoscope-tizen/main.magnetoscope.js",
  },
  "Philips TV": {
    prod: "https://static.francetv.fr/magnetoscope-whaleos/main.magnetoscope.js",
    pre: "https://static.ftv-preprod.fr/magnetoscope-whaleos/main.magnetoscope.js",
  },
  Orange: {
    prod: "https://proxy-mediation.yatta.francetv.fr/prod/v2/static/magnetoscope-orange/main.magnetoscope.js",
    pre: "https://proxy-mediation.yatta.francetv.fr/preprod/v2/static/magnetoscope-orange/main.magnetoscope.js",
  },
};

const _magnetoScriptUrl = _magnetoScriptUrls[platform.type][__BACKEND_TARGET__ === "pre" ? "pre" : "prod"].toString();

export abstract class PlayerHelper {
  static readonly load = (): Promise<void> => {
    return loadJS(_magnetoScriptUrl)
      .then(() => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (typeof (window as any).magnetoscope === "undefined") {
          throw new Error("Magnetoscope is undefined");
        } else {
          Log.app.warn("Succeeded to load magnetoJS");
        }
      })
      .catch(error => {
        Log.app.error("Failed to load magnetoscope:", error);
      });
  };
}
